/* TPM Hobby & Collection — theme.js  ·  Conception par Norvika */
(function () {
  'use strict';

  var I18N = window.TPM_I18N || {};
  var CART = I18N.cart || {};

  /* ---------- Helpers partagés ---------- */
  var routeRoot = (typeof Shopify !== 'undefined' && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  if (routeRoot.slice(-1) !== '/') routeRoot += '/';

  function esc(s) {
    return (s == null ? '' : String(s)).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Formatte des cents selon shop.money_format (gère les variantes {{amount}}...)
  function formatMoney(cents) {
    var fmt = I18N.moneyFormat || '${{amount}}';
    function fmtNum(n, precision, thousands, decimal) {
      var num = (n / 100).toFixed(precision);
      var parts = num.split('.');
      var dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, key) {
      switch (key) {
        case 'amount': return fmtNum(cents, 2, ',', '.');
        case 'amount_no_decimals': return fmtNum(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmtNum(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmtNum(cents, 0, '.', ',');
        case 'amount_with_space_separator': return fmtNum(cents, 2, ' ', '.');
        case 'amount_no_decimals_with_space_separator': return fmtNum(cents, 0, ' ', '.');
        default: return fmtNum(cents, 2, ',', '.');
      }
    });
  }

  function whenIdle(fn) {
    if ('requestIdleCallback' in window) window.requestIdleCallback(fn, { timeout: 1600 });
    else setTimeout(fn, 500);
  }

  // Confinement du focus (Tab) dans un dialog ouvert (role=dialog aria-modal=true).
  // Le focus initial + la restauration à la fermeture sont déjà gérés par chaque overlay ;
  // ceci ajoute uniquement la boucle du Tab tant que le dialog est ouvert (WCAG 2.4.3 / 2.1.2).
  var FOCUSABLE_SEL = 'a[href], area[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  function getFocusable(container) {
    return Array.prototype.slice.call(container.querySelectorAll(FOCUSABLE_SEL)).filter(function (el) {
      return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
    });
  }
  function trapTab(container, e) {
    if (e.key !== 'Tab') return;
    var f = getFocusable(container);
    if (!f.length) { e.preventDefault(); return; }
    var first = f[0], last = f[f.length - 1], active = document.activeElement;
    if (e.shiftKey) {
      if (active === first || !container.contains(active)) { e.preventDefault(); last.focus(); }
    } else {
      if (active === last || !container.contains(active)) { e.preventDefault(); first.focus(); }
    }
  }

  function postJSON(path, body) {
    return fetch(routeRoot + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.ok ? r.json() : Promise.reject(r); });
  }

  // Verrou de défilement partagé (tiroir de panier + menu plein écran).
  // On verrouille HTML *et* BODY: sur ce thème l'élément de défilement est <html>
  // (document.scrollingElement), donc overflow:hidden sur body seul ne bloque rien.
  // Compteur => plusieurs overlays peuvent coexister sans se déverrouiller l'un l'autre.
  var _scrollLockCount = 0;
  function lockScroll() {
    _scrollLockCount++;
    if (_scrollLockCount === 1) {
      document.documentElement.classList.add('is-scroll-locked');
      document.body.classList.add('is-scroll-locked');
    }
  }
  function unlockScroll() {
    _scrollLockCount = Math.max(0, _scrollLockCount - 1);
    if (_scrollLockCount === 0) {
      document.documentElement.classList.remove('is-scroll-locked');
      document.body.classList.remove('is-scroll-locked');
    }
  }

  /* ---------- Panneau départements : DEUX modes, un seul balisage ----------
     - bouton MENU (hamburger)        -> plein écran, modal, verrou de défilement
     - « Départements » de la barre   -> PETIT DÉROULANT ancré sous l'élément de
       nav, comme le thème actuel de la boutique. Desktop seulement (sous 1024
       la barre de nav est masquée, donc le déclencheur est hors d'atteinte).
     Le déroulant n'est PAS une fenêtre modale : pas d'aria-modal, pas de piège
     au clavier, pas de verrou de défilement. Il se ferme au clic dehors, à
     Échap, et dès que le focus sort du panneau. */
  function initMenu() {
    var overlay = document.querySelector('[data-menu-overlay]');
    if (!overlay) return;
    var header = document.querySelector('[data-header]');
    var triggers = Array.prototype.slice.call(document.querySelectorAll('[data-menu-open]')); // hamburger + « Départements »
    var closers = overlay.querySelectorAll('[data-menu-close]');
    var mega = overlay.querySelector('[data-megamenu]');
    var desktop = window.matchMedia('(min-width: 1024px)');
    var lastTrigger = null;
    var isDropdown = false;

    /* Ouverture au SURVOL (comme le theme actuel de la boutique), mais SEULEMENT
       sur un vrai pointeur de souris. `(hover: hover) and (pointer: fine)` exclut
       le tactile et le stylet : sur tablette, un « survol » emule au premier
       contact ouvrirait le menu quand l'utilisateur voulait juste cliquer.
       Le clic et le clavier restent les chemins d'activation universels. */
    var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
    var HOVER_CLOSE_DELAY = 200; // ms : laisse traverser l'espace bouton -> panneau
    var hoverTimer = null;
    var hoverBlocked = false;    // pose par un clic qui ferme, leve quand le pointeur sort

    function isOpen() { return overlay.classList.contains('is-open'); }
    function hoverEligible(t) {
      return !!(t && finePointer.matches && desktop.matches && t.hasAttribute('data-menu-dropdown'));
    }
    function cancelHoverClose() { if (hoverTimer) { clearTimeout(hoverTimer); hoverTimer = null; } }
    function scheduleHoverClose() {
      cancelHoverClose();
      hoverTimer = setTimeout(function () {
        hoverTimer = null;
        if (isOpen() && isDropdown) close();
      }, HOVER_CLOSE_DELAY);
    }
    function setExpanded(v) { triggers.forEach(function (t) { t.setAttribute('aria-expanded', v ? 'true' : 'false'); }); }

    // Aligne le bord gauche du déroulant sur l'élément de nav qui l'ouvre.
    function anchor(trigger) {
      if (!header || !trigger) return;
      var dx = trigger.getBoundingClientRect().left - header.getBoundingClientRect().left;
      overlay.style.setProperty('--dd-x', Math.max(0, Math.round(dx)) + 'px');
    }

    function open(trigger) {
      lastTrigger = trigger || null;
      isDropdown = !!(trigger && trigger.hasAttribute('data-menu-dropdown') && desktop.matches);
      overlay.classList.toggle('menu-overlay--dd', isDropdown);
      if (isDropdown) {
        anchor(trigger);
        overlay.removeAttribute('aria-modal'); // ce n'est pas une fenêtre modale
      } else {
        overlay.setAttribute('aria-modal', 'true');
        document.body.classList.add('menu-open');
        lockScroll(); // verrou de défilement (html + body) : plein écran seulement
      }
      overlay.classList.add('is-open');
      overlay.scrollTop = 0;
      setExpanded(true);
      if (mega && mega.__reset) mega.__reset(); // master en mobile, 1er rayon en desktop
    }
    function close(refocus) {
      cancelHoverClose();
      if (!isOpen()) return;
      overlay.classList.remove('is-open');
      overlay.classList.remove('menu-overlay--dd');
      overlay.setAttribute('aria-modal', 'true');
      document.body.classList.remove('menu-open');
      unlockScroll();
      setExpanded(false);
      if (mega) mega.classList.remove('is-detail');
      if (refocus && lastTrigger) { try { lastTrigger.focus(); } catch (err) {} }
      isDropdown = false;
      lastTrigger = null;
    }

    triggers.forEach(function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        cancelHoverClose();
        // Rebascule d'un mode à l'autre si l'autre déclencheur est utilisé.
        var wantsDropdown = !!(t.hasAttribute('data-menu-dropdown') && desktop.matches);
        if (isOpen() && wantsDropdown === isDropdown) {
          close();
          // Le pointeur est encore sur le bouton : sans ce verrou, le survol
          // rouvrirait aussitot et le clic de fermeture n'aurait aucun effet
          // visible. Leve des que le pointeur quitte le bouton.
          // ⚠️ `e.detail > 0` distingue un VRAI clic de souris d'une activation
          // au clavier (Entree/Espace, detail 0). Sans ce test, fermer au
          // clavier posait le verrou alors que le pointeur n'a jamais touche le
          // bouton, et le survol restait mort jusqu'a un aller-retour complet
          // de la souris. Vu au test le 2026-08-20.
          if (hoverEligible(t) && e.detail > 0 && t.matches(':hover')) hoverBlocked = true;
          return;
        }
        if (isOpen()) close();
        open(t);
      });

      // SURVOL : ouvre le deroulant (desktop, souris uniquement).
      t.addEventListener('mouseenter', function () {
        if (!hoverEligible(t) || hoverBlocked) return;
        cancelHoverClose();
        if (isOpen() && isDropdown && lastTrigger === t) return;
        if (isOpen()) close();
        open(t);
      });
      t.addEventListener('mouseleave', function () {
        hoverBlocked = false;
        if (!hoverEligible(t)) return;
        scheduleHoverClose();
      });
    });

    // Le panneau reste ouvert tant que la souris est DEDANS.
    overlay.addEventListener('mouseenter', function () {
      if (isOpen() && isDropdown) cancelHoverClose();
    });
    overlay.addEventListener('mouseleave', function () {
      if (isOpen() && isDropdown && finePointer.matches) scheduleHoverClose();
    });
    closers.forEach(function (c) { c.addEventListener('click', function () { close(true); }); });

    document.addEventListener('keydown', function (e) {
      if (!isOpen()) return;
      if (e.key === 'Escape') { close(true); return; }
      // Piège au clavier réservé au plein écran : un déroulant doit laisser
      // la tabulation continuer dans la page.
      if (e.key === 'Tab' && !isDropdown) trapTab(overlay, e);
    });

    // Déroulant : sortir du panneau au clavier le referme.
    overlay.addEventListener('focusout', function (e) {
      if (!isOpen() || !isDropdown) return;
      var to = e.relatedTarget;
      if (to && (overlay.contains(to) || (lastTrigger && lastTrigger.contains(to)))) return;
      close();
    });

    // fermer quand on clique un LIEN du panneau (pas les boutons de département)
    overlay.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { close(); }); });

    // clic en dehors
    document.addEventListener('click', function (e) {
      if (!isOpen()) return;
      if (overlay.contains(e.target)) return;
      for (var i = 0; i < triggers.length; i++) { if (triggers[i].contains(e.target)) return; }
      close();
    });

    // Le déroulant suit son déclencheur quand la fenêtre change de taille, et
    // se referme si on passe sous le seuil desktop (la barre de nav disparaît).
    window.addEventListener('resize', function () {
      if (!isOpen() || !isDropdown) return;
      if (!desktop.matches) { close(); return; }
      anchor(lastTrigger);
    });
  }

  /* ---------- Mega-menu master-detail (deroulant desktop / drill mobile) ---------- */
  function initMegaMenu() {
    var mega = document.querySelector('[data-megamenu]');
    if (!mega) return;
    var deptBtns = Array.prototype.slice.call(mega.querySelectorAll('[data-dept-btn]'));
    var panels = Array.prototype.slice.call(mega.querySelectorAll('[data-panel]'));
    var backs = Array.prototype.slice.call(mega.querySelectorAll('[data-panel-back]'));
    var desktop = window.matchMedia('(min-width: 1024px)');

    function activate(id) {
      panels.forEach(function (p) { p.classList.toggle('is-active', p.id === id); });
      deptBtns.forEach(function (b) {
        var on = b.getAttribute('data-target') === id;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
      mega.classList.add('is-detail'); // n'a d'effet visuel qu'en mobile
      // Mobile : remonter le menu en haut pour voir le détail (avec « Retour ») dès le premier coup d'œil
      if (!desktop.matches) {
        var ov = document.querySelector('[data-menu-overlay]');
        if (ov) ov.scrollTop = 0;
      }
    }
    function toMaster() {
      mega.classList.remove('is-detail');
      panels.forEach(function (p) { p.classList.remove('is-active'); });
      deptBtns.forEach(function (b) { b.classList.remove('is-active'); b.setAttribute('aria-expanded', 'false'); });
    }
    function ensureDefault() {
      if (desktop.matches && deptBtns.length && !mega.querySelector('.megamenu__panel.is-active')) {
        activate(deptBtns[0].getAttribute('data-target'));
      }
    }

    /* Changement de rayon : CLIC + SURVOL.
       Le theme actuel de la boutique change de rayon au survol (regle CSS
       `.has-babymenu:hover .babymenu`), verifie en DOM le 2026-08-20. On le
       reproduit ICI, sans retirer le clic que William avait demande : les deux
       chemins activent le meme rayon, donc rien n'est perdu.
       Pour revenir au clic seul, passer RAYON_HOVER a false. */
    var RAYON_HOVER = true;
    var HOVER_INTENT = 120; // ms : evite de changer de rayon en traversant la liste
    var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
    var intentTimer = null;

    deptBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        if (intentTimer) { clearTimeout(intentTimer); intentTimer = null; }
        activate(b.getAttribute('data-target'));
      });

      b.addEventListener('mouseenter', function () {
        if (!RAYON_HOVER || !finePointer.matches || !desktop.matches) return;
        if (intentTimer) clearTimeout(intentTimer);
        intentTimer = setTimeout(function () {
          intentTimer = null;
          activate(b.getAttribute('data-target'));
        }, HOVER_INTENT);
      });
      b.addEventListener('mouseleave', function () {
        if (intentTimer) { clearTimeout(intentTimer); intentTimer = null; }
      });
    });
    backs.forEach(function (bk) { bk.addEventListener('click', toMaster); });

    // Etat initial : le menu est FERME (overlay en display:none). On ne deplie
    // donc AUCUN departement : aria-expanded="true" sur un panneau invisible
    // ment aux lecteurs d'ecran et fait annoncer un menu ouvert qui ne l'est pas.
    // L'etat par defaut du desktop est pose a l'OUVERTURE, par __reset().
    function menuIsOpen() {
      var ov = document.querySelector('[data-menu-overlay]');
      return !!(ov && ov.classList.contains('is-open'));
    }
    toMaster();
    if (desktop.addEventListener) {
      desktop.addEventListener('change', function () {
        if (!menuIsOpen()) { toMaster(); return; }
        desktop.matches ? ensureDefault() : toMaster();
      });
    }
    // exposé pour que l'ouverture du menu réinitialise l'état (mobile = master, desktop = 1er rayon)
    mega.__reset = function () { toMaster(); ensureDefault(); };
  }

  /* ---------- Recherche: reset auto du champ (#12) ---------- */
  function initSearchReset() {
    document.querySelectorAll('[data-search-form]').forEach(function (form) {
      var input = form.querySelector('input[type="search"]');
      if (!input) return;
      form.addEventListener('submit', function () {
        setTimeout(function () { input.value = ''; }, 0);
      });
    });
  }

  /* ---------- Sliders produits: fleches gauche/droite (#4) ---------- */
  function initSliders(root) {
    (root || document).querySelectorAll('[data-slider]').forEach(function (slider) {
      if (slider.dataset.tpmSlider) return; slider.dataset.tpmSlider = '1';
      var track = slider.querySelector('[data-slider-track]');
      var prev = slider.querySelector('[data-slider-prev]');
      var next = slider.querySelector('[data-slider-next]');
      if (!track) return;

      function step() {
        var first = track.firstElementChild;
        var gap = parseFloat(getComputedStyle(track).columnGap || '16') || 16;
        var w = first ? first.getBoundingClientRect().width : 240;
        return (w + gap) * Math.max(1, Math.floor(track.clientWidth / (w + gap)));
      }
      function update() {
        if (!prev || !next) return;
        var max = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- Hero carrousel ---------- */
  function initHero(root) {
    (root || document).querySelectorAll('[data-hero]').forEach(function (hero) {
      if (hero.dataset.tpmHero) return; hero.dataset.tpmHero = '1';
      var slides = Array.prototype.slice.call(hero.querySelectorAll('.hero__slide'));
      var dots = Array.prototype.slice.call(hero.querySelectorAll('.hero__dot'));
      if (slides.length < 2) return;
      var i = 0, timer = null;
      var delay = parseInt(hero.getAttribute('data-interval'), 10) || 5500;
      function go(n) {
        slides[i].classList.remove('is-active');
        if (dots[i]) dots[i].classList.remove('is-active');
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('is-active');
        if (dots[i]) dots[i].classList.add('is-active');
      }
      function play() { stop(); if (!IN_EDITOR && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) timer = setInterval(function () { go(i + 1); }, delay); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      dots.forEach(function (d, idx) { d.addEventListener('click', function () { go(idx); play(); }); });
      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('mouseleave', play);
      // WCAG 2.2.2 : mise en pause au focus clavier (en plus du survol souris)
      hero.addEventListener('focusin', stop);
      hero.addEventListener('focusout', play);
      // Exposé pour l'éditeur : arrêt de l'intervalle quand la section est retirée
      // (évite les intervalles orphelins sur des noeuds détachés) et pause à la sélection.
      hero._tpmStop = stop;
      hero._tpmPlay = play;
      play();
    });
  }

  /* ---------- Reveal on scroll ---------- */
  var IN_EDITOR = !!(window.Shopify && Shopify.designMode);
  function initReveal(root) {
    root = root || document;
    var els = root.querySelectorAll('.reveal:not(.is-visible)');
    // Dans l'éditeur de thème (ou sans IntersectionObserver), on rend tout visible
    // immédiatement : le client ne doit jamais voir du contenu invisible en éditant,
    // et une section re-rendue par l'éditeur ne repasse pas par l'observer d'origine.
    if (IN_EDITOR || !('IntersectionObserver' in window) || !els.length) {
      els.forEach(function (e) { e.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Galerie produit ---------- */
  function initProductGallery(root) {
    var gal = (root || document).querySelector('[data-product-gallery]');
    if (!gal || gal.dataset.tpmGallery) return; gal.dataset.tpmGallery = '1';
    var main = gal.querySelector('[data-gallery-main]');
    var thumbs = gal.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var src = t.getAttribute('data-full');
        if (main && src) {
          /* Une image qui porte un srcset ignore son src : il faut remplacer les
             DEUX, sinon le clic sur une vignette ne change plus la photo. */
          var ss = t.getAttribute('data-srcset');
          if (ss) main.srcset = ss; else main.removeAttribute('srcset');
          main.src = src;
          /* Les dimensions reelles suivent la photo, sinon la page saute (CLS)
             quand on passe d'une image carree a une image portrait. */
          var w = t.getAttribute('data-w');
          var h = t.getAttribute('data-h');
          if (w && h) { main.setAttribute('width', w); main.setAttribute('height', h); }
        }
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  }

  /* ==========================================================================
     TIROIR DE PANIER (mini-cart drawer) — upsell natif, ajax /cart.js
     ========================================================================== */
  var drawer = { el: null, body: null, foot: null, cross: null, crossList: null, subtotalEl: null, lastFocus: null, crossAnchor: null };

  function openDrawer(anchorId) {
    if (!drawer.el) { window.location.href = CART.viewCartUrl || (routeRoot + 'cart'); return; }
    drawer.lastFocus = document.activeElement;
    drawer.el.classList.add('is-open');
    drawer.el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-open');
    lockScroll();
    var closeBtn = drawer.el.querySelector('[data-cart-close]');
    if (closeBtn && closeBtn.focus) closeBtn.focus();
    fetchCart().then(function (cart) {
      renderCart(cart);
      loadCross(anchorId, cart);
    });
  }
  function closeDrawer() {
    if (!drawer.el) return;
    drawer.el.classList.remove('is-open');
    drawer.el.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-open');
    unlockScroll();
    if (drawer.lastFocus && drawer.lastFocus.focus) drawer.lastFocus.focus();
  }
  function fetchCart() {
    return fetch(routeRoot + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }
  function updateCount(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      if (cart.item_count > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    });
  }
  function updateShipBar(cart) {
    document.querySelectorAll('[data-ship-bar]').forEach(function (bar) {
      var threshold = parseInt(bar.getAttribute('data-threshold'), 10);
      if (!threshold) return;
      var msg = bar.querySelector('[data-ship-msg]');
      var fill = bar.querySelector('[data-ship-fill]');
      var total = cart.total_price;
      var remaining = threshold - total;
      var pct = Math.min(100, Math.round(total / threshold * 100));
      if (fill) fill.style.width = pct + '%';
      if (remaining > 0) {
        bar.classList.remove('is-unlocked');
        var tpl = bar.getAttribute('data-remaining-tpl') || CART.shipRemaining || '%amount%';
        if (msg) msg.textContent = tpl.replace('%amount%', formatMoney(remaining));
      } else {
        bar.classList.add('is-unlocked');
        if (msg) msg.textContent = bar.getAttribute('data-unlocked') || CART.shipUnlocked || '';
      }
    });
  }
  function lineHTML(item) {
    var img = item.image || (item.featured_image && item.featured_image.url) || '';
    var variant = (item.variant_title && item.variant_title.indexOf('Default') === -1) ? item.variant_title : '';
    return '' +
      '<div class="cd-item">' +
        '<a class="cd-item__media" href="' + esc(item.url) + '">' +
          (img ? '<img src="' + esc(img) + '&width=200" alt="" width="86" height="86" loading="lazy">' : '') +
        '</a>' +
        '<div class="cd-item__info">' +
          '<a class="cd-item__title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
          (variant ? '<span class="cd-item__variant">' + esc(variant) + '</span>' : '') +
          '<span class="cd-item__price">' + formatMoney(item.final_line_price) + '</span>' +
          '<div class="cd-item__controls">' +
            '<div class="cd-qty">' +
              '<button type="button" class="cd-qty__btn" data-qty-dec data-key="' + esc(item.key) + '" data-qty="' + item.quantity + '" aria-label="-">&minus;</button>' +
              '<span class="cd-qty__val">' + item.quantity + '</span>' +
              '<button type="button" class="cd-qty__btn" data-qty-inc data-key="' + esc(item.key) + '" data-qty="' + item.quantity + '" aria-label="+">+</button>' +
            '</div>' +
            '<button type="button" class="cd-item__remove" data-line-remove data-key="' + esc(item.key) + '">' + esc(CART.remove || 'Retirer') + '</button>' +
          '</div>' +
        '</div>' +
      '</div>';
  }
  function renderCart(cart) {
    updateCount(cart);
    updateShipBar(cart);
    if (!drawer.body) return;
    if (cart.item_count === 0) {
      drawer.body.innerHTML = '<div class="cd-empty"><p>' + esc(CART.drawerEmpty || '') + '</p>' +
        '<button type="button" class="btn btn--dark" data-cart-close>' + esc(CART.continue || '') + '</button></div>';
      if (drawer.foot) drawer.foot.hidden = true;
      if (drawer.cross) drawer.cross.hidden = true;
      return;
    }
    var html = '<div class="cd-items">';
    cart.items.forEach(function (it) { html += lineHTML(it); });
    html += '</div>';
    drawer.body.innerHTML = html;
    if (drawer.subtotalEl) drawer.subtotalEl.textContent = formatMoney(cart.total_price);
    if (drawer.foot) drawer.foot.hidden = false;
  }
  function changeLine(key, qty) {
    if (qty < 0) qty = 0;
    postJSON('cart/change.js', { id: key, quantity: qty })
      .then(function (cart) { renderCart(cart); })
      .catch(function () {});
  }
  function loadCross(anchorId, cart) {
    if (!drawer.cross || !drawer.crossList) return;
    var anchor = anchorId;
    if (!anchor && cart && cart.items && cart.items.length) anchor = cart.items[cart.items.length - 1].product_id;
    if (!anchor || !cart || cart.item_count === 0) { drawer.cross.hidden = true; return; }
    if (String(anchor) === String(drawer.crossAnchor) && drawer.crossList.children.length) { drawer.cross.hidden = false; return; }
    var url = routeRoot + 'recommendations/products?section_id=' + encodeURIComponent(CART.crossSectionId || 'cart-recommendations') +
      '&product_id=' + anchor + '&intent=related&limit=' + (CART.crossLimit || 4);
    fetch(url).then(function (r) { return r.text(); }).then(function (text) {
      var doc = new DOMParser().parseFromString(text, 'text/html');
      var cards = doc.querySelectorAll('.cross-card');
      if (cards.length) {
        var h = '';
        Array.prototype.forEach.call(cards, function (c) { h += c.outerHTML; });
        drawer.crossList.innerHTML = h;
        drawer.cross.hidden = false;
        drawer.crossAnchor = anchor;
      } else {
        drawer.cross.hidden = true;
      }
    }).catch(function () { drawer.cross.hidden = true; });
  }
  function initCartDrawer() {
    drawer.el = document.querySelector('[data-cart-drawer]');
    if (!drawer.el) return;
    drawer.body = drawer.el.querySelector('[data-cart-body]');
    drawer.foot = drawer.el.querySelector('[data-cart-foot]');
    drawer.cross = drawer.el.querySelector('[data-cart-cross]');
    drawer.crossList = drawer.el.querySelector('[data-cart-cross-list]');
    drawer.subtotalEl = drawer.el.querySelector('[data-cart-subtotal]');

    document.querySelectorAll('[data-cart-open]').forEach(function (t) {
      t.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); });
    });
    drawer.el.querySelectorAll('[data-cart-close]').forEach(function (c) { c.addEventListener('click', closeDrawer); });
    document.addEventListener('keydown', function (e) {
      if (!drawer.el.classList.contains('is-open')) return;
      if (e.key === 'Escape') { closeDrawer(); return; }
      if (e.key === 'Tab') trapTab(drawer.el, e);
    });
    // délégation dans le corps (quantités, retrait, bouton « continuer » de l'état vide)
    drawer.body.addEventListener('click', function (e) {
      var close = e.target.closest('[data-cart-close]');
      if (close) { closeDrawer(); return; }
      var dec = e.target.closest('[data-qty-dec]');
      var inc = e.target.closest('[data-qty-inc]');
      var rem = e.target.closest('[data-line-remove]');
      if (dec) changeLine(dec.getAttribute('data-key'), parseInt(dec.getAttribute('data-qty'), 10) - 1);
      else if (inc) changeLine(inc.getAttribute('data-key'), parseInt(inc.getAttribute('data-qty'), 10) + 1);
      else if (rem) changeLine(rem.getAttribute('data-key'), 0);
    });
  }

  /* ---------- Ajout rapide au panier (cartes + cross-sell) -> tiroir ---------- */
  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-quick-add]') : null;
      if (!btn) return;
      e.preventDefault();
      var id = btn.getAttribute('data-variant-id');
      var pid = btn.getAttribute('data-product-id');
      if (!id || btn.classList.contains('is-busy')) return;
      btn.classList.add('is-busy');
      postJSON('cart/add.js', { items: [{ id: id, quantity: 1 }] })
        .then(function () {
          btn.classList.remove('is-busy');
          btn.classList.add('is-done');
          setTimeout(function () { btn.classList.remove('is-done'); }, 1600);
          openDrawer(pid);
        })
        .catch(function () {
          btn.classList.remove('is-busy');
          var card = btn.closest('.pcard');
          var link = card && card.querySelector('.pcard__media-link, .pcard__title-link');
          if (link) window.location.href = link.getAttribute('href');
        });
    });
  }

  /* ---------- Formulaire produit (fiche) : sélection de variante + ajout ajax -> tiroir ---------- */
  function initProductForm(root) {
    var form = (root || document).querySelector('[data-product-form]');
    if (!form || form.dataset.tpmForm) return; form.dataset.tpmForm = '1';
    var idInput = form.querySelector('[data-variant-id-input]');
    var addBtn = form.querySelector('[data-add-btn]');
    var pid = form.getAttribute('data-product-id');

    var variants = null;
    var vScript = form.querySelector('[data-product-variants]');
    if (vScript) { try { variants = JSON.parse(vScript.textContent); } catch (err) { variants = null; } }
    var selects = Array.prototype.slice.call(form.querySelectorAll('[data-variant-option]'));

    function updateVariant() {
      if (!variants) return;
      var chosen = selects
        .slice()
        .sort(function (a, b) { return a.getAttribute('data-option-index') - b.getAttribute('data-option-index'); })
        .map(function (s) { return s.value; });
      var match = null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var ok = true;
        for (var j = 0; j < chosen.length; j++) { if (v.options[j] !== chosen[j]) { ok = false; break; } }
        if (ok) { match = v; break; }
      }
      if (!match) return;
      if (idInput) idInput.value = match.id;
      var priceEl = document.querySelector('.product__price');
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      if (addBtn) addBtn.disabled = !match.available;
    }
    selects.forEach(function (s) { s.addEventListener('change', updateVariant); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var id = idInput ? idInput.value : null;
      if (!id || (addBtn && addBtn.classList.contains('is-busy'))) return;
      if (addBtn) addBtn.classList.add('is-busy');
      postJSON('cart/add.js', { items: [{ id: id, quantity: 1 }] })
        .then(function () { if (addBtn) addBtn.classList.remove('is-busy'); openDrawer(pid); })
        .catch(function () { if (addBtn) addBtn.classList.remove('is-busy'); form.submit(); });
    });
  }

  /* ---------- Slots de recommandations (fiche) : chargement différé + repli ---------- */
  /* ---------- Dedoublonnage des blocs de suggestions --------------------- */
  // « Souvent achetes ensemble » et « Ca va bien avec » tapent tous les deux
  // dans les recommandations natives (le second retombe sur intent=related
  // quand aucun complementaire n'est configure). Sans ce filtre, le meme
  // produit apparait deux fois sur la fiche.
  function dedupeRecos() {
    var seen = {};
    var current = document.querySelector('[data-current-product-id]');
    if (current) seen[current.getAttribute('data-current-product-id')] = 1;
    document.querySelectorAll('[data-bundle] [data-bundle-item][data-product-id]').forEach(function (cb) {
      seen[cb.getAttribute('data-product-id')] = 1;
    });
    document.querySelectorAll('.reco-slot').forEach(function (slot) {
      slot.querySelectorAll('.pcard[data-product-id]').forEach(function (card) {
        var id = card.getAttribute('data-product-id');
        if (seen[id]) { if (card.parentNode) card.parentNode.removeChild(card); return; }
        seen[id] = 1;
      });
      var grid = slot.querySelector('.pgrid');
      var sec = slot.querySelector('section');
      if (sec) sec.hidden = !!(grid && !grid.querySelector('.pcard'));
    });
  }

  function initRecoSlots(root) {
    var slots = Array.prototype.slice.call((root || document).querySelectorAll('[data-reco-load]'))
      .filter(function (s) { if (s.dataset.tpmReco) return false; s.dataset.tpmReco = '1'; return true; });
    if (!slots.length) return;
    function fetchInto(slot, url, fallback) {
      fetch(url).then(function (r) { return r.text(); }).then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var fresh = doc.querySelector('[data-reco-load]') || doc.querySelector('.shopify-section') || doc.body;
        var content = fresh ? fresh.innerHTML.trim() : '';
        var hasProducts = content && content.indexOf('class="pcard') !== -1;
        if (hasProducts) { slot.innerHTML = content; dedupeRecos(); }
        else if (fallback) { fetchInto(slot, fallback, null); }
      }).catch(function () {});
    }
    whenIdle(function () {
      slots.forEach(function (slot, i) {
        var url = slot.getAttribute('data-url');
        var fb = slot.getAttribute('data-fallback-url');
        if (!url) return;
        setTimeout(function () { fetchInto(slot, url, fb); }, i * 180);
      });
    });
  }

  /* ---------- Bundle « Souvent achetés ensemble » (fiche) ---------- */
  function initBundle(root) {
    var bundle = (root || document).querySelector('[data-bundle]');
    if (!bundle || bundle.dataset.tpmBundle) return; bundle.dataset.tpmBundle = '1';
    var url = bundle.getAttribute('data-url');
    var recosEl = bundle.querySelector('[data-bundle-recos]');
    var totalEl = bundle.querySelector('[data-bundle-total]');
    var addBtn = bundle.querySelector('[data-bundle-add]');

    function recalc() {
      var total = 0;
      bundle.querySelectorAll('[data-bundle-anchor], [data-bundle-item]').forEach(function (cb) {
        if (cb.checked) total += parseInt(cb.getAttribute('data-price'), 10) || 0;
      });
      if (totalEl) totalEl.textContent = formatMoney(total);
    }
    function wire() {
      bundle.querySelectorAll('.bundle__check').forEach(function (cb) { cb.addEventListener('change', recalc); });
      recalc();
    }
    function load() {
      if (!url) return;
      fetch(url).then(function (r) { return r.text(); }).then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var freshRecos = doc.querySelector('[data-bundle-recos]');
        var items = freshRecos ? freshRecos.querySelectorAll('.bundle__item') : [];
        if (items.length) {
          var h = '';
          Array.prototype.forEach.call(items, function (it) { h += it.outerHTML; });
          recosEl.innerHTML = h;
          bundle.hidden = false;
          wire();
          dedupeRecos();
        }
      }).catch(function () {});
    }
    whenIdle(load);

    if (addBtn) addBtn.addEventListener('click', function () {
      var items = [];
      bundle.querySelectorAll('[data-bundle-anchor], [data-bundle-item]').forEach(function (cb) {
        if (cb.checked) { var vid = cb.getAttribute('data-variant-id'); if (vid) items.push({ id: vid, quantity: 1 }); }
      });
      if (!items.length) return;
      addBtn.classList.add('is-busy');
      postJSON('cart/add.js', { items: items })
        .then(function () { addBtn.classList.remove('is-busy'); openDrawer(null); })
        .catch(function () { addBtn.classList.remove('is-busy'); });
    });
  }

  /* ---------- Recherche predictive (native Shopify /search/suggest.json) ---------- */
  function initPredictiveSearch() {
    var L = I18N.predictive || {};
    document.querySelectorAll('[data-predictive-search]').forEach(function (root) {
      var input = root.querySelector('[data-predictive-input]');
      var results = root.querySelector('[data-predictive-results]');
      var form = root.querySelector('[data-search-form]');
      if (!input || !results || !form) return;

      var controller = null;
      var timer = null;
      var activeIndex = -1;

      function esc(s) { return (s == null ? '' : String(s)).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
      // Aligné sur le format monétaire Shopify (shop.money_format) comme le reste du thème.
      // suggest.json renvoie des montants en dollars (chaîne) => on convertit en cents pour formatMoney.
      function money(v) { var n = parseFloat(v); return isNaN(n) ? '' : formatMoney(Math.round(n * 100)); }
      function stripDept(t) { var p = String(t).split(' | '); return p[p.length - 1]; }

      function close() {
        results.setAttribute('hidden', '');
        results.innerHTML = '';
        input.setAttribute('aria-expanded', 'false');
        activeIndex = -1;
      }
      function open() { results.removeAttribute('hidden'); input.setAttribute('aria-expanded', 'true'); }
      function items() { return Array.prototype.slice.call(results.querySelectorAll('[data-pred-item]')); }

      function setActive(idx) {
        var list = items();
        list.forEach(function (el) { el.setAttribute('aria-selected', 'false'); });
        activeIndex = idx;
        if (idx >= 0 && list[idx]) {
          list[idx].setAttribute('aria-selected', 'true');
          list[idx].scrollIntoView({ block: 'nearest' });
        }
      }

      function render(data, q) {
        var r = (data.resources && data.resources.results) || {};
        var products = r.products || [];
        var collections = r.collections || [];
        var queries = r.queries || [];
        var html = '<div class="predictive__panel">';
        var hasAny = products.length || collections.length || queries.length;

        if (products.length) {
          html += '<div class="predictive__group"><p class="predictive__label">' + esc(L.products || 'Produits') + '</p>';
          products.forEach(function (p) {
            var img = (p.featured_image && p.featured_image.url) || p.image || '';
            var priceHtml = '';
            if (p.price_min != null && p.price_max != null && p.price_min !== p.price_max) {
              priceHtml = money(p.price_min);
            } else if (p.price != null) {
              priceHtml = money(p.price);
            }
            html += '<a class="predictive__item" data-pred-item role="option" href="' + esc(p.url) + '">' +
              (img ? '<img class="predictive__thumb" src="' + esc(img) + '&width=84" alt="" loading="lazy" width="42" height="42">' : '<span class="predictive__thumb predictive__thumb--empty">?</span>') +
              '<span class="predictive__body"><span class="predictive__title">' + esc(p.title) + '</span>' +
              (priceHtml ? '<span class="predictive__price">' + priceHtml + '</span>' : '') +
              '</span></a>';
          });
          html += '</div>';
        }

        if (collections.length) {
          html += '<div class="predictive__group"><p class="predictive__label">' + esc(L.collections || 'Rayons') + '</p>';
          collections.forEach(function (c) {
            html += '<a class="predictive__item predictive__item--text" data-pred-item role="option" href="' + esc(c.url) + '">' + esc(stripDept(c.title)) + '</a>';
          });
          html += '</div>';
        }

        if (queries.length) {
          html += '<div class="predictive__group"><p class="predictive__label">' + esc(L.suggestions || 'Suggestions') + '</p>';
          queries.forEach(function (qq) {
            html += '<a class="predictive__item predictive__item--text" data-pred-item role="option" href="' + esc(qq.url) + '">' + esc(qq.text) + '</a>';
          });
          html += '</div>';
        }

        if (!hasAny) {
          html += '<p class="predictive__empty">' + esc(L.none || 'Aucune suggestion.') + '</p>';
        }

        html += '<a class="predictive__viewall" data-pred-item href="' + esc(form.action) + '?q=' + encodeURIComponent(q) + '&type=product">' + esc(L.viewAll || 'Voir tous les résultats') + ' « ' + esc(q) + ' »</a>';
        html += '</div>';
        results.innerHTML = html;
        open();
        setActive(-1);
      }

      function fetchSuggest(q) {
        if (controller) controller.abort();
        controller = ('AbortController' in window) ? new AbortController() : null;
        var base = (typeof Shopify !== 'undefined' && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
        if (base.slice(-1) !== '/') base += '/';
        var suggestUrl = base + 'search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection,query&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(suggestUrl, controller ? { signal: controller.signal } : undefined)
          .then(function (res) { return res.json(); })
          .then(function (data) { render(data, q); })
          .catch(function (e) { if (e && e.name === 'AbortError') return; });
      }

      input.addEventListener('input', function () {
        var q = input.value.trim();
        if (timer) clearTimeout(timer);
        if (q.length < 2) { close(); return; }
        results.innerHTML = '<div class="predictive__panel"><p class="predictive__loading">' + esc(L.loading || 'Recherche…') + '</p></div>';
        open();
        timer = setTimeout(function () { fetchSuggest(q); }, 250);
      });

      input.addEventListener('keydown', function (e) {
        var list = items();
        if (e.key === 'ArrowDown') {
          if (results.hasAttribute('hidden') || !list.length) return;
          e.preventDefault(); setActive((activeIndex + 1) % list.length);
        } else if (e.key === 'ArrowUp') {
          if (results.hasAttribute('hidden') || !list.length) return;
          e.preventDefault(); setActive((activeIndex - 1 + list.length) % list.length);
        } else if (e.key === 'Enter') {
          if (activeIndex >= 0 && list[activeIndex]) { e.preventDefault(); window.location.href = list[activeIndex].getAttribute('href'); }
        } else if (e.key === 'Escape') {
          close();
        }
      });

      input.addEventListener('focus', function () {
        if (input.value.trim().length >= 2 && results.innerHTML) open();
      });

      document.addEventListener('click', function (e) {
        if (!root.contains(e.target)) close();
      });
    });
  }

  /* ==========================================================================
     MODE PREVIEW (thème non publié) — garder le contexte draft à la bascule de langue
     Sans ça, le form de localisation redirige vers /en SANS preview_theme_id, donc
     /en charge le thème LIVE. Actif UNIQUEMENT quand preview_theme_id est dans l'URL;
     aucun effet sur le site publié.
     ========================================================================== */
  function initPreviewLocale() {
    var pid = null, pb = null;
    // Shopify retire souvent preview_theme_id de l'URL après le 1er chargement (cookie preview).
    // On persiste donc le contexte en sessionStorage pour continuer à le porter sur toutes les
    // pages ET à travers la bascule de langue, même quand l'URL est nettoyée.
    try {
      var qs = new URLSearchParams(location.search);
      pid = qs.get('preview_theme_id');
      pb = qs.get('pb');
      if (pid) {
        sessionStorage.setItem('tpm_preview_id', pid);
        if (pb !== null) sessionStorage.setItem('tpm_preview_pb', pb);
      } else {
        pid = sessionStorage.getItem('tpm_preview_id');
        pb = sessionStorage.getItem('tpm_preview_pb');
      }
    } catch (e) { /* sessionStorage indisponible: on retombe sur le param d'URL seul */ }
    if (!pid) return;
    var extra = 'preview_theme_id=' + encodeURIComponent(pid);
    if (pb !== null && pb !== '') extra += '&pb=' + encodeURIComponent(pb);

    // 1) Bascule de langue: naviguer directement vers l'URL localisée en gardant le preview
    document.querySelectorAll('form[action*="localization"]').forEach(function (f) {
      var buttons = f.querySelectorAll('button[name="locale_code"]');
      var active = f.querySelector('button[name="locale_code"].is-active') || f.querySelector('button[name="locale_code"][aria-current]');
      var currentRoot = active ? (active.getAttribute('data-locale-root') || '/') : '/';
      buttons.forEach(function (b) {
        b.addEventListener('click', function (e) {
          var targetRoot = b.getAttribute('data-locale-root') || '/';
          e.preventDefault();
          var path = location.pathname;
          if (currentRoot && currentRoot !== '/' && path.indexOf(currentRoot) === 0) {
            path = path.slice(currentRoot.length) || '/';
          }
          var newPath = (targetRoot && targetRoot !== '/') ? (targetRoot + (path === '/' ? '' : path)) : path;
          if (newPath.charAt(0) !== '/') newPath = '/' + newPath;
          location.href = newPath + '?' + extra;
        });
      });
    });

    // 2) Propager le preview aux liens internes pour ne jamais retomber sur le live
    document.querySelectorAll('a[href^="/"]').forEach(function (a) {
      var href = a.getAttribute('href');
      if (!href || href.charAt(1) === '/' || href.indexOf('preview_theme_id=') !== -1) return;
      a.setAttribute('href', href + (href.indexOf('?') === -1 ? '?' : '&') + extra);
    });
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  // Inits liés à des éléments précis, ré-appelables sur un conteneur (section re-rendue
  // par l'éditeur de thème). Chacun a son garde-fou dataset -> jamais de double-binding.
  // Les singletons délégués sur document (menu, tiroir de panier, quick-add, recherche)
  // ne sont PAS ici : ils sont initialisés une seule fois et couvrent déjà le contenu ajouté.
  function initSection(root) {
    initSliders(root);
    initHero(root);
    initReveal(root);
    initProductGallery(root);
    initProductForm(root);
    initRecoSlots(root);
    initBundle(root);
  }

  ready(function () {
    // Éditeur de thème : garantit la visibilité même avant l'exécution du JS de reveal.
    if (IN_EDITOR) document.documentElement.classList.add('shopify-design-mode');

    initPreviewLocale();
    initMenu();
    initMegaMenu();
    initSearchReset();
    initCartDrawer();
    initQuickAdd();
    initPredictiveSearch();
    initSection(document);

    // ---- Intégration à l'éditeur de thème Shopify (Section Rendering API) ----
    // Quand l'éditeur re-rend une section sans recharger la page, le nouveau HTML
    // contient des .reveal à opacity:0 sans observer attaché -> on ré-initialise.
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target || document;
      initSection(root);
    });
    document.addEventListener('shopify:section:unload', function (e) {
      var root = e.target;
      if (!root) return;
      // Coupe les intervalles du carrousel pour éviter les noeuds détachés qui tournent.
      root.querySelectorAll('[data-hero]').forEach(function (h) { if (h._tpmStop) h._tpmStop(); });
    });
    // Sélection d'une section/diapo dans l'éditeur : contenu toujours visible + carrousel en pause.
    function onSelect(e) {
      var root = e.target || document;
      root.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
      root.querySelectorAll('[data-hero]').forEach(function (h) { if (h._tpmStop) h._tpmStop(); });
    }
    document.addEventListener('shopify:section:select', onSelect);
    document.addEventListener('shopify:block:select', onSelect);
    document.addEventListener('shopify:section:deselect', function (e) {
      var root = e.target || document;
      root.querySelectorAll('[data-hero]').forEach(function (h) { if (h._tpmPlay) h._tpmPlay(); });
    });
  });
})();

/* ==========================================================================
   Sections editables (M2) — barre d'annonce, compte a rebours, video au clic,
   galerie agrandie. Module autonome : n'interfere pas avec le code ci-dessus.
   ========================================================================== */
(function () {
  'use strict';

  // (la preference de mouvement reduit est geree en CSS pour le defilement continu)

  /* --- Barre d'annonce : rotation automatique ---------------------------- */
  function initAnnonces(root) {
    root.querySelectorAll('.tpm-annonce[data-mode="rotate"]').forEach(function (el) {
      if (el._tpmTimer) { clearInterval(el._tpmTimer); el._tpmTimer = null; }
      var items = el.querySelectorAll('.tpm-annonce__rotator .tpm-annonce__item');
      if (items.length < 2) return;
      var i = 0;
      var wait = (parseInt(el.getAttribute('data-interval'), 10) || 5) * 1000;
      el._tpmTimer = setInterval(function () {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, wait);
    });
  }

  /* --- Compte a rebours -------------------------------------------------- */
  function pad(n) { return n < 10 ? '0' + n : String(n); }

  // Safari refuse « 2026-12-25 18:00 » (espace au lieu de T) et renvoie NaN la
  // ou Chrome tolere. On analyse la chaine nous-memes, en heure locale.
  function parseTargetDate(raw) {
    var v = String(raw == null ? '' : raw).trim();
    if (!v) return NaN;
    var m = v.match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[T\s]+(\d{1,2}):(\d{2})(?::(\d{2}))?)?/);
    if (m) {
      var d = new Date(+m[1], +m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0), +(m[6] || 0));
      return isNaN(d.getTime()) ? NaN : d.getTime();
    }
    var t = new Date(v).getTime();
    return isNaN(t) ? NaN : t;
  }

  function initCountdowns(root) {
    root.querySelectorAll('[data-countdown]').forEach(function (el) {
      if (el._tpmTimer) { clearInterval(el._tpmTimer); el._tpmTimer = null; }
      var target = parseTargetDate(el.getAttribute('data-target'));
      if (isNaN(target)) {
        // Date invalide (champ vide, « 2026-12-25 18:00 » avec une espace, etc.).
        // On masque l'horloge cote client, et on l'explique dans l'editeur de
        // theme pour que la personne qui configure la section voie le probleme.
        el.hidden = true;
        if (IN_EDITOR) {
          el.hidden = false;
          el.innerHTML = '';
          var warn = document.createElement('p');
          warn.className = 'tpm-count__done';
          warn.textContent = el.getAttribute('data-invalid') || '';
          el.appendChild(warn);
        }
        return;
      }
      el.hidden = false;
      var slots = {
        days: el.querySelector('[data-days]'),
        hours: el.querySelector('[data-hours]'),
        minutes: el.querySelector('[data-minutes]'),
        seconds: el.querySelector('[data-seconds]')
      };
      var tick = function () {
        var diff = target - Date.now();
        if (diff <= 0) {
          clearInterval(el._tpmTimer);
          el._tpmTimer = null;
          var msg = el.getAttribute('data-ended') || '';
          el.innerHTML = '';
          var p = document.createElement('p');
          p.className = 'tpm-count__done';
          p.textContent = msg;
          el.appendChild(p);
          return;
        }
        var s = Math.floor(diff / 1000);
        var d = Math.floor(s / 86400);
        var h = Math.floor((s % 86400) / 3600);
        var m = Math.floor((s % 3600) / 60);
        var sec = s % 60;
        if (slots.days) slots.days.textContent = String(d);
        if (slots.hours) slots.hours.textContent = pad(h);
        if (slots.minutes) slots.minutes.textContent = pad(m);
        if (slots.seconds) slots.seconds.textContent = pad(sec);
      };
      tick();
      el._tpmTimer = setInterval(tick, 1000);
    });
  }

  /* --- Video : chargement de l'iframe seulement au clic ------------------ */
  function playFacade(facade) {
    var src = facade.getAttribute('data-src');
    if (!src) return;
    var frame = document.createElement('iframe');
    frame.setAttribute('src', src);
    frame.setAttribute('title', facade.querySelector('.tpm-video__play-text')
      ? facade.querySelector('.tpm-video__play-text').textContent : 'video');
    frame.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
    frame.setAttribute('allowfullscreen', 'allowfullscreen');
    frame.setAttribute('loading', 'lazy');
    facade.replaceWith(frame);
    frame.focus();
  }

  /* --- Galerie : agrandissement ------------------------------------------ */
  var lastFocus = null;

  function closeLightbox() {
    var box = document.querySelector('.tpm-lightbox');
    if (!box) return;
    box.remove();
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
    lastFocus = null;
  }

  function openLightbox(btn) {
    var url = btn.getAttribute('data-full');
    if (!url) return;
    closeLightbox();
    lastFocus = btn;
    var box = document.createElement('div');
    box.className = 'tpm-lightbox';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    var img = document.createElement('img');
    img.src = url;
    var inner = btn.querySelector('img');
    img.alt = inner ? inner.alt : '';
    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'tpm-lightbox__close';
    close.setAttribute('aria-label', btn.getAttribute('data-close-label') || 'Fermer');
    close.textContent = '×';
    box.appendChild(img);
    box.appendChild(close);
    document.body.appendChild(box);
    document.body.style.overflow = 'hidden';
    close.focus();
    close.addEventListener('click', closeLightbox);
    box.addEventListener('click', function (e) { if (e.target === box) closeLightbox(); });
  }

  document.addEventListener('click', function (e) {
    var play = e.target.closest ? e.target.closest('.tpm-video__play') : null;
    if (play) {
      var facade = play.closest('[data-video-facade]');
      if (facade) { e.preventDefault(); playFacade(facade); return; }
    }
    var open = e.target.closest ? e.target.closest('[data-gallery-open]') : null;
    if (open) { e.preventDefault(); openLightbox(open); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeLightbox();
  });

  function initTpmSections(root) {
    if (!root || !root.querySelectorAll) return;
    initAnnonces(root);
    initCountdowns(root);
  }

  function boot() { initTpmSections(document); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initTpmSections(e.target || document);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target;
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('.tpm-annonce, [data-countdown]').forEach(function (el) {
      if (el._tpmTimer) { clearInterval(el._tpmTimer); el._tpmTimer = null; }
    });
  });
})();
/* ==========================================================================
   Filtres de collection (facettes) — M5
   Sans JavaScript : le formulaire se soumet normalement et la page se recharge.
   Avec JavaScript : UNE seule requete par interaction via la Section Rendering
   API. On ne remplace QUE les zones qui changent (resultats, puces, compteur,
   pagination, contenu du formulaire) au lieu d'ecraser toute la section : le
   focus clavier, le curseur dans un champ, l'etat ouvert du panneau mobile et
   les groupes deplies survivent a la mise a jour. Aucun defilement programme.
   ========================================================================== */
(function () {
  'use strict';

  var inflight = null;

  function sectionRoot(el) {
    return el && el.closest ? el.closest('[data-facet-section]') : null;
  }

  function setLoading(root, on) {
    var res = root.querySelector('.coll-results');
    if (res) res.classList.toggle('is-loading', !!on);
  }

  function buildUrl(form) {
    var data = new FormData(form);
    var params = new URLSearchParams();
    data.forEach(function (v, k) {
      if (v === '' || v == null) return;
      params.append(k, v);
    });
    var base = form.getAttribute('action') || window.location.pathname;
    var qs = params.toString();
    return qs ? base + '?' + qs : base;
  }

  /* ---------- Etat a preserver au travers d'une mise a jour ---------------- */

  function q(v) { return String(v == null ? '' : v).replace(/["\\]/g, '\\$&'); }

  // Selecteur stable, valable AVANT et APRES le re-rendu (jamais une reference
  // de noeud : le noeud d'origine peut avoir ete remplace).
  var FOCUS_SEL = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';

  function stableSelector(el) {
    if (!el || !el.tagName) return null;
    if (el.id) return '[id="' + q(el.id) + '"]';
    if (el.name) {
      var s = el.tagName.toLowerCase() + '[name="' + q(el.name) + '"]';
      if (el.type === 'checkbox' || el.type === 'radio') s += '[value="' + q(el.value) + '"]';
      return s;
    }
    // Les liens (puces, « effacer ») n'ont ni id ni name : on les retrouve par href.
    var href = el.getAttribute && el.getAttribute('href');
    if (href) return 'a[href="' + q(href) + '"]';
    return null;
  }

  function capture(root) {
    var st = { sel: null, idx: -1, value: null, start: null, end: null, details: [], panel: null, expanded: null };
    var ae = document.activeElement;
    if (ae && ae !== document.body && root.contains(ae)) {
      st.sel = stableSelector(ae);
      // Filet de securite : le rang de l'element dans l'ordre de tabulation.
      // Sans lui, tabuler hors du champ de prix renvoyait le focus au tout debut
      // du document des que la grille se re-rendait (WCAG 2.4.3).
      st.idx = Array.prototype.indexOf.call(root.querySelectorAll(FOCUS_SEL), ae);
      if (typeof ae.value === 'string') st.value = ae.value;
      try { st.start = ae.selectionStart; st.end = ae.selectionEnd; } catch (err) { /* input[type=number] */ }
    }
    root.querySelectorAll('.coll-facet').forEach(function (d) { st.details.push(!!d.open); });
    var body = root.querySelector('.coll-facets__body');
    if (body) st.panel = body.classList.contains('is-open');
    var toggle = root.querySelector('[data-facets-toggle]');
    if (toggle) st.expanded = toggle.getAttribute('aria-expanded');
    return st;
  }

  function restore(root, st) {
    // Panneau mobile : l'etat est LU avant le remplacement, jamais apres.
    if (st.panel != null) {
      var body = root.querySelector('.coll-facets__body');
      if (body) body.classList.toggle('is-open', st.panel);
    }
    if (st.expanded != null) {
      var toggle = root.querySelector('[data-facets-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', st.expanded);
    }
    var groups = root.querySelectorAll('.coll-facet');
    for (var i = 0; i < groups.length && i < st.details.length; i++) groups[i].open = st.details[i];

    var el = st.sel ? root.querySelector(st.sel) : null;
    if (!el && st.idx > -1) el = root.querySelectorAll(FOCUS_SEL)[st.idx] || null;
    if (!el) return;
    // On ne reecrit jamais par-dessus ce que la personne est en train de taper.
    if (typeof st.value === 'string' && el.type !== 'checkbox' && el.type !== 'radio' && 'value' in el) {
      if (el.value !== st.value) el.value = st.value;
    }
    try { el.focus({ preventScroll: true }); } catch (err) { try { el.focus(); } catch (e2) { return; } }
    if (st.start != null && el.setSelectionRange) {
      try { el.setSelectionRange(st.start, st.end); } catch (err) { /* type=number */ }
    }
  }

  /* ---------- Remplacement cible des zones qui changent -------------------- */

  function swapInner(root, fresh, selector, parentSelector, where) {
    var cur = root.querySelector(selector);
    var nw = fresh.querySelector(selector);
    if (cur && nw) { cur.innerHTML = nw.innerHTML; return; }
    if (cur && !nw) { cur.parentNode.removeChild(cur); return; }
    if (!cur && nw) {
      var parent = root.querySelector(parentSelector);
      if (parent) parent.insertAdjacentHTML(where || 'afterbegin', nw.outerHTML);
    }
  }

  function swapOuter(root, fresh, selector, where) {
    var cur = root.querySelector(selector);
    var nw = fresh.querySelector(selector);
    if (cur && nw) { cur.outerHTML = nw.outerHTML; return; }
    if (cur && !nw) { cur.parentNode.removeChild(cur); return; }
    if (!cur && nw) root.insertAdjacentHTML(where || 'beforeend', nw.outerHTML);
  }

  function apply(root, fresh) {
    // Le panneau de filtres apparait ou disparait (0 resultat, par ex.) :
    // la structure change, on remplace tout. Le focus est restaure apres.
    var structureChanged = !!root.querySelector('.coll-facets') !== !!fresh.querySelector('.coll-facets');
    if (structureChanged) { root.innerHTML = fresh.innerHTML; return; }

    // Le menu de tri vit HORS des zones remplacees (barre d'outils) : on
    // resynchronise sa valeur, sinon un retour arriere laissait « Prix croissant »
    // affiche pendant que la grille etait triee par nouveautes.
    var curSort = root.querySelector('.coll-toolbar__sort select[name="sort_by"]');
    var nwSort = fresh.querySelector('.coll-toolbar__sort select[name="sort_by"]');
    if (curSort && nwSort && curSort.value !== nwSort.value) curSort.value = nwSort.value;

    swapInner(root, fresh, '.coll-header__meta', '.coll-header__inner', 'beforeend');
    swapInner(root, fresh, '.coll-facets__chips', '.coll-facets__body', 'afterbegin');
    swapInner(root, fresh, '.coll-facets__form', '.coll-facets__body', 'beforeend');
    swapInner(root, fresh, '.coll-results', null, null);
    swapOuter(root, fresh, '.coll-layout > .pagination, [data-facet-section] > .pagination', 'beforeend');
  }

  function announce(root) {
    var live = root.querySelector('[data-facet-status]');
    if (!live) return;
    var meta = root.querySelector('.coll-header__meta') || root.querySelector('.coll-toolbar__count');
    var txt = meta ? meta.textContent.replace(/\s+/g, ' ').trim() : '';
    if (txt && live.textContent !== txt) live.textContent = txt;
  }

  /* ---------- Historique : pushState, pour que « Retour » revienne ---------- */

  function tagInitialState() {
    var root = document.querySelector('[data-facet-section]');
    if (!root) return;
    var s = window.history.state;
    if (!s || !s.tpmFacets) {
      window.history.replaceState({ tpmFacets: root.getAttribute('data-facet-section') }, '', window.location.href);
    }
  }

  function pushUrl(root, url, mode) {
    if (mode === 'none') return;
    var st = { tpmFacets: root.getAttribute('data-facet-section') };
    if (mode === 'replace') window.history.replaceState(st, '', url);
    else window.history.pushState(st, '', url);
  }

  /* ---------- Rendu ------------------------------------------------------- */

  /* Retour en haut apres un changement de page.
     Signale par Lau le 2026-09-09 : la pagination d une collection est rendue en
     AJAX, donc le navigateur ne remonte pas comme il le ferait sur un vrai
     changement de page. On arrivait sur la page 2 au milieu de la liste.
     On vise le haut de la grille, pas le haut du document, et on retire la
     hauteur de l en-tete collant sinon les premiers produits passent dessous. */
  function scrollToResults(root) {
    var target = root.querySelector('.coll-results') || root;
    var header = document.querySelector('.site-header');
    var offset = 0;
    if (header) {
      var pos = window.getComputedStyle(header).position;
      if (pos === 'sticky' || pos === 'fixed') offset = header.offsetHeight;
    }
    var y = target.getBoundingClientRect().top + window.pageYOffset - offset - 12;
    if (y < 0) y = 0;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    try { window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' }); }
    catch (e) { window.scrollTo(0, y); }
  }

  function render(root, url, historyMode, scrollUp) {
    var id = root.getAttribute('data-facet-section');
    if (!id) return;
    if (inflight) inflight.abort();
    inflight = new AbortController();
    setLoading(root, true);
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    fetch(url + sep + 'section_id=' + encodeURIComponent(id), { signal: inflight.signal })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-facet-section="' + id + '"]');
        if (!fresh) { window.location.href = url; return; }
        var state = capture(root);
        apply(root, fresh);
        restore(root, state);
        if (scrollUp) scrollToResults(root);
        pushUrl(root, url, historyMode);
        announce(root);
        document.dispatchEvent(new CustomEvent('tpm:facets:updated', { detail: { root: root } }));
      })
      .catch(function (e) {
        if (e && e.name === 'AbortError') return;
        window.location.href = url;
      })
      .then(function () { setLoading(root, false); inflight = null; });
  }

  /* ---------- Evenements --------------------------------------------------- */

  // Cases a cocher, menu de tri ET champs de prix : une requete par changement.
  // Les champs de prix passent par « change » (sortie du champ ou touche Entree)
  // et JAMAIS par « input » : sinon la requete part au milieu de la saisie, la
  // valeur revient formatee du serveur (« 10.00 » pendant qu'on tape « 100 ») et
  // le clavier mobile se referme. C'est ce qui rendait le filtre inutilisable.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.form) return;
    if (!t.form.hasAttribute('data-facet-form')) return;
    var root = sectionRoot(t.form) || sectionRoot(t);
    if (!root) return;
    render(root, buildUrl(t.form));
  });

  // Soumission classique interceptee (bouton « Appliquer », touche Entree)
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.hasAttribute || !f.hasAttribute('data-facet-form')) return;
    var root = sectionRoot(f);
    if (!root) return;
    e.preventDefault();
    render(root, buildUrl(f));
  });

  // Liens : puces, « effacer », etiquettes de repli, pagination
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a') : null;
    if (!a || a.target === '_blank' || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var root = sectionRoot(a);
    if (!root) return;
    var inPagination = !!a.closest('.pagination');
    var inFacets = a.closest('.coll-facets') || inPagination;
    if (!inFacets) return;
    if (!a.getAttribute('href')) return;
    e.preventDefault();
    render(root, a.getAttribute('href'), undefined, inPagination);
  });

  // Bouton « Filtrer » sur mobile
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-facets-toggle]') : null;
    if (!btn) return;
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    var open = panel.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  // Bouton « Retour » du navigateur : on re-rend l'etat precedent sur place.
  window.addEventListener('popstate', function (e) {
    if (!e.state || !e.state.tpmFacets) return;
    var root = document.querySelector('[data-facet-section="' + e.state.tpmFacets + '"]')
      || document.querySelector('[data-facet-section]');
    if (!root) return;
    render(root, window.location.href, 'none');
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tagInitialState);
  } else {
    tagInitialState();
  }
})();
